export default "__VITE_ASSET__Bu3oik3J__"